import ListStoresPage from './ListStoresPage';
import { skipToken } from '@reduxjs/toolkit/dist/query';
import { useGetAgencyByIdQuery } from '../../agencies/agency.api-slice';
import { useParams } from 'react-router-dom';

const ListStoresForAgency: React.FC = () => {
  const { id } = useParams();
  const { data } = useGetAgencyByIdQuery(id ?? skipToken);

  return <ListStoresPage agency={data} scope={'agency'} />;
};

export default ListStoresForAgency;
